import PropTypes from "prop-types";

const TransitionArrowUnfilledIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => {
  return (
    <svg
      className={className}
      style={style}
      data-no-pointer={noPointer}
      width={width || size || 21}
      height={height || size || 21}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
      fill="none"
    >
      <title>{title}</title>
      <path
        stroke={color || "currentColor"}
        strokeWidth="2"
        d="M17.459 1.683a4.45 4.45 0 0 1 1.858 1.858c.506.947.683 1.863.683 4.15v5.617c0 2.288-.177 3.204-.683 4.15a4.45 4.45 0 0 1-1.858 1.859c-.947.506-1.863.683-4.15.683H7.691c-2.288 0-3.204-.177-4.15-.683a4.45 4.45 0 0 1-1.859-1.858C1.177 16.512 1 15.596 1 13.309V7.691c0-2.288.177-3.204.683-4.15a4.45 4.45 0 0 1 1.858-1.859C4.488 1.177 5.404 1 7.691 1h5.617c2.288 0 3.204.177 4.15.683z"
      />
      <g transform="translate(4.5 7.5)">
        <rect
          width="9"
          height="2"
          y="2"
          fill={color || "currentColor"}
          rx="1"
        />
        <path
          stroke={color || "currentColor"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6.5 0 10 3 6.5 6"
        />
      </g>
    </svg>
  );
};

TransitionArrowUnfilledIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  color: PropTypes.string,
  noPointer: PropTypes.bool,
  title: PropTypes.string
};

export default TransitionArrowUnfilledIcon;
